/* eslint-disable camelcase */
import React from 'react'
import { useSchemaAction, useSchemaState, useUpdateSchemaContext } from 'contexts'
import { customPanelTitles } from 'utils/constants/customPanelTitles'
import { PanelButtonBar } from 'components/common'
import { defaultIntervals } from 'utils/constants'
import { IntervalDTO } from 'models/schema'
import ExecutionTimePicker from './ExecutionTimePicker'
import FrequencySelector from './FrequencySelector'
import ActiveToggler from './ActiveToggler'
import SpecificDaysSelector from './SpecificDaysSelector'

type AutoMailPanelProps = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const AutoMailPanel = ({ setOpen }: AutoMailPanelProps) => {
  const { currentTableKey, intervals } = useSchemaState()

  const { setIntervals } = useSchemaAction()
  const { mutate } = useUpdateSchemaContext()

  const [currentInterval, setCurrentInterval] = React.useState<IntervalDTO | undefined>(undefined)

  React.useEffect(() => {
    if (intervals && currentTableKey) {
      const found = intervals.find((interval) => interval.tableName === currentTableKey)
      if (found) {
        setCurrentInterval(found)
      }
    }
  }, [intervals, currentTableKey])

  const saveInterval = () => {
    const payloadIntervals = intervals.map((interval) =>
      interval.tableName === currentTableKey ? currentInterval : interval,
    )
    setIntervals(payloadIntervals as Array<IntervalDTO>)
    mutate()
  }

  const handleConfirm = () => {
    setOpen(false)
    saveInterval()
  }

  const handleCancel = () => {
    setCurrentInterval(
      intervals?.find((interval) => interval.tableName === currentTableKey) as IntervalDTO,
    )
  }

  const handleDefault = () => {
    setCurrentInterval(
      defaultIntervals.find((interval) => interval.tableName === currentTableKey) as IntervalDTO,
    )
  }

  const disableConfirm = React.useMemo(() => {
    if (currentInterval?.executionSchedule.specificDays?.length === 0)
      return "Veuillez sélectionner au moins un jour pour l'envoi de mail."
    return ''
  }, [currentInterval])
  const containerProps = {
    className: 'flex flex-col bg-white',
  }

  if (currentInterval === undefined) {
    return (
      <div {...containerProps}>
        <div className="flex items-center w-full h-12">{`Envoi de mail automatique: ${customPanelTitles[currentTableKey]}`}</div>
      </div>
    )
  }

  return (
    <>
      <div {...containerProps}>
        <div
          className="flex items-start p-1 mb-4 text-lg font-semibold"
          style={{ height: '36px' }}
        >
          {`Envoi de mail automatique: ${customPanelTitles[currentTableKey]}`}
        </div>
        <ActiveToggler
          interval={currentInterval}
          setInterval={setCurrentInterval as React.Dispatch<React.SetStateAction<IntervalDTO>>}
        />
        {currentInterval.isActive && (
          <div className="flex flex-col mt-4 ">
            <div className="mb-4">
              <FrequencySelector
                interval={currentInterval}
                setInterval={
                  setCurrentInterval as React.Dispatch<React.SetStateAction<IntervalDTO>>
                }
              />
            </div>
            <div className="mb-4">
              <SpecificDaysSelector
                interval={currentInterval}
                setInterval={
                  setCurrentInterval as React.Dispatch<React.SetStateAction<IntervalDTO>>
                }
              />
            </div>
            {/* TODO DELETE DATE SELECTOR if validated */}
            {/* <div className="mb-4">
              <DateSelector
                type="start"
                interval={currentInterval}
                setInterval={
                  setCurrentInterval as React.Dispatch<React.SetStateAction<IntervalDTO>>
                }
              />
            </div> */}
            {/* <div className="mb-4">
              <DateSelector
                type="end"
                interval={currentInterval}
                setInterval={
                  setCurrentInterval as React.Dispatch<React.SetStateAction<IntervalDTO>>
                }
              />
            </div> */}
            <div className="mb-4">
              <ExecutionTimePicker
                interval={currentInterval}
                setInterval={
                  setCurrentInterval as React.Dispatch<React.SetStateAction<IntervalDTO>>
                }
              />
            </div>
          </div>
        )}
      </div>
      <PanelButtonBar
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        onDefault={handleDefault}
        disableConfirm={disableConfirm}
      />
    </>
  )
}

export default AutoMailPanel
